import Icon from '@mdi/react';
import { mdiMessageBadgeOutline } from '@mdi/js';
import {useState, useContext} from 'react';
import {UserContext} from '../../contexts/UserContext';
import {ChatContext} from '../../contexts/ChatContext';
import {unreadNotificationsFunc} from '../../utils/unreadNotifications';
import moment from 'moment';

const Notification = () => {

	const [isOpen, setIsOpen] = useState(false);
	const {user} = useContext(UserContext);

	const {notifications, userChats, allUsers, markAllNotificationsAsRead, markSpecificNotificationAsRead} = useContext(ChatContext);
	
	const unreadNotifications = unreadNotificationsFunc(notifications);
	const modifiedNotifications = notifications.map((notif) => {
		const sender = allUsers.find(senderUser => senderUser._id === notif.senderId)

		return{
			...notif,
			senderName: sender?.name
		}
	})
	// console.log('us', userChats)
	return(
		<div className="notifications">
			<div className="notifications-icon" onClick={() => setIsOpen(!isOpen)}>
				<Icon path={mdiMessageBadgeOutline} size={1} />

				{unreadNotifications?.length === 0 ? null : (
					<span className="notification-count">
						<span>{unreadNotifications?.length}</span>
					</span>
				)}

			</div>
			{isOpen ?
			<div className="notifications-box">
				<div className="notifications-header">
					<h3>Notifications</h3>

					<div className="mark-as-read" onClick={() => markAllNotificationsAsRead(notifications)}>
						Mark all as read
					</div>
				</div>
				{modifiedNotifications?.length === 0 ? <span className="d-flex justify-content-center">No notifications</span> : null}
				{modifiedNotifications && modifiedNotifications.map((modNotif, index) => {
					return(
						<div key={index} className={modNotif.isRead ? 'notification' : 'notification not-read'} onClick={() => markSpecificNotificationAsRead(modNotif, userChats, user, notifications)}>
							<span>{`${modNotif.senderName} sent you a new message`}</span>
							<span className="notification-time">{moment(modNotif.date).calendar()}</span>
						</div>
					)
				})}
			</div>
			: <></>}
		</div>
	)
}

export default Notification;
